<template>
  <div class="common_backgroundImg">
    <div class="common_content">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="6" :md="5">
          <side title="公开查询" src="/image/evaluationStaff/icon3.png" :list="list" />
        </el-col>
        <el-col :xs="24" :sm="18" :md="19">
          <div>
            <router-view></router-view>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>

import side from "@/views/admin/components/side.vue";
export default {
  components: {
    side,
  },
  data() {
    return {
      list:[
        /*
        {
          path: "/enquiry/athleteList",
          name: "运动员列表"
        },
        */
        {
          path: "/enquiry/certificateAuthenticity",
          name: "运动员资格证书查询"
        }
        
      ],
      
    };
  },
};
</script>

<style lang="less" scoped>

</style>